import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getOrderDeliveries,
  resetDelivery,
} from "../../../../REDUX/actions/delivery";

export const useDeliveryData = ({
  orderId,
  realDeliveryDate,
  estimatedDeliveryDate,
  isEstimatedDate,
  setFormData,
}) => {
  const dispatch = useDispatch();
  const { orderDeliveries } = useSelector((state) => state.deliveryReducer);

  useEffect(() => {
    dispatch(
      getOrderDeliveries({
        orderId,
        realDeliveryDate,
        isEstimatedDate,
        estimatedDeliveryDate,
      })
    );

    return () => dispatch(resetDelivery());
  }, [dispatch, orderId, realDeliveryDate, estimatedDeliveryDate]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      orders: orderDeliveries?.map(
        (delivery) => delivery?.attributes?.commande?.data?.id
      ),
    }));
  }, [orderDeliveries, setFormData]);

  return { orderDeliveries };
};
